module.exports = __webpack_public_path__ + "img/icon_product_main_regist.d3f1f0cd.svg";